<script setup lang="ts">
/* Types */
import { TabTypes } from '@/types/components/basket-time.types'

const model = defineModel<TabTypes>()
</script>

<template>
  <v-tabs v-model="model">
    <v-tab :value="TabTypes.FAST" :ripple="false">Как можно скорее</v-tab>
    <v-tab :value="TabTypes.DELIVERY_ON_TIME" :ripple="false">Ко времени</v-tab>
  </v-tabs>
</template>

<style scoped lang="scss">
.v-slide-group {
  height: 40px;
  background: $button-background;
  border-radius: 100px;
}

:deep(.v-tab__slider) {
  z-index: -1 !important;
  height: 100% !important;
  padding: 3px 0 !important;
  background: $white !important;
  border-radius: 100px !important;
}

:deep(.v-btn__overlay),
:deep(.v-btn__underlay) {
  display: none !important;
}

.v-tab {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  min-width: 0 !important;
  max-width: 100%;
  height: 34px !important;
  padding: 0;
  margin: 3px;
  font-size: 14px;
  font-weight: 600;
  color: $text-black !important;
  text-transform: none;
  letter-spacing: unset;

  &:hover {
    background-color: transparent !important;
  }

  &::before {
    display: none;
    opacity: 0 !important;
  }

  &::after {
    display: none;
    opacity: 0 !important;
  }

  &--selected {
    font-weight: 800;
    box-shadow: none !important;
  }
}
</style>
